import { supabase } from '../supabaseClient';

export async function submitRenovationLead({
  category,
  customerName,
  customerEmail,
  customerPhone,
  district,
  projectDetails,
  timeline,
  budgetRange,
  userId,
  sourceEstimate,
}) {
  const { error } = await supabase.from('renovation_leads').insert({
    category,
    customer_name: customerName,
    customer_email: customerEmail,
    customer_phone: customerPhone,
    district,
    project_details: projectDetails,
    timeline: timeline || null,
    budget_range: budgetRange || null,
    user_id: userId || null,
    source_estimate: sourceEstimate || null,
  });
  if (error) throw error;
}
